function AskSection() {
  return (
    <div className="ask-section-container">
      <h1 className="faq-title">Preguntamos lo que tú te preguntas</h1>
      <div className="ask-section-grid">
        <div className="ask-section-card">
          <h3>¿Qué es la medicina integrativa?</h3>
          <p>
            Es un enfoque que combina lo mejor de la medicina convencional con terapias complementarias respaldadas por la ciencia. No se trata de elegir una u otra, sino de integrar ambas para que tú obtengas el mejor resultado posible.
          </p>
        </div>
        <div className="ask-section-card">
          <h3>¿Es segura la medicina natural?</h3>
          <p>
            Lo "natural" no siempre es sinónimo de inocuo. Algunas plantas o suplementos pueden interferir con tus tratamientos actuales. Mi labor es asesorarte para que cualquier complemento que utilices sea seguro y eficaz para tu organismo.
          </p>
        </div>
        <div className="ask-section-card">
          <h3>¿Por qué enfocar el control de peso?</h3>
          <p>
            El peso no es solo estética; es el pilar de la prevención de diabetes y enfermedades cardiovasculares. Trabajamos en un plan que no se basa en dietas restrictivas, sino en un cambio metabólico real y sostenible.
          </p>
        </div>
      </div>
    </div>
  );
}

export default AskSection;
